import { Observable } from "rxjs/Observable"

import {
    dashboardBaseUrl,
    getURLSearchParams,
    postAttachmentBody,
    getAuthHeader,
} from "./utils/network-config"
import { getList, getItem, putItem } from "./utils/entity-network-requests"

const entityName = "attachment"

function postFileItem(
    entityType,
    { attachment, fields },
    token,
    baseUrl = dashboardBaseUrl
) {
    const searchParams = getURLSearchParams({
        topic_id: fields.topic_id,
        attachment_title: fields.attachment_title,
        file_name: attachment.name,
        token,
    }).toString()
    const headers = getAuthHeader(token)
    return Observable.ajax
        .getJSON(`${baseUrl}/${entityType}/link?${searchParams}`, headers)
        .map((data) => data.attachment)
        .mergeMap((data) =>
            readFileAsPromise(attachment).then((event) => ({
                body: event.currentTarget.result,
                data,
            }))
        )
        .mergeMap(({ body, data }) => {
            return fetch(data.attachment_upload_url, {
                method: "PUT",
                body,
            }).then(() => data)
        })
        .mergeMap(({ attachment_url, key }) => {
            const postBody = postAttachmentBody({
                ...fields,
                attachment_url,
                key,
                mimetype: attachment.type,
            })
            return Observable.ajax.post(
                `${baseUrl}/${entityType}?token=${token}`,
                postBody,
                headers
            )
        })
        .map((xhr) => xhr.response)
        .catch((error) => console.log(error))
}

function readFileAsPromise(file) {
    return new Promise((resolve, reject) => {
        var fr = new FileReader()
        fr.onload = resolve
        fr.readAsArrayBuffer(file)
    })
}

function getFileList(entityType, parameters, token) {
    const urlParameters = {
        topic: parameters.get("topic"),
        order_time: "DESC",
    }
    return getList(entityType, urlParameters, token)
}

function deleteFileItem(entityType, id, token, baseUrl = dashboardBaseUrl) {
    return Observable.ajax
        .delete(`${baseUrl}/${entityType}/${id}?token=${token}`)
        .map((xhr) => xhr.response)
}

export const getAttachmentList = (token, parameters) =>
    getFileList(entityName, parameters, token)
export const getAttachmentItem = (token, id) => getItem(entityName, id, token)
export const putAttachmentItem = (token, id, attachment) =>
    putItem(entityName, id, attachment, token)
export const postAttachmentItem = (token, attachment) =>
    postFileItem(entityName, attachment, token)
export const deleteAttachmentItem = (token, id) =>
    deleteFileItem(entityName, id, token)
